module.exports = __webpack_public_path__ + "static/media/HAUX_MAIS_VIDA_3.8c17ee80.pdf";